// extracted by mini-css-extract-plugin
export default {"wrapperLinkChannel":"LinkChannel_wrapperLinkChannel__3rXiE","visibleText":"LinkChannel_visibleText__rCnTK","hiddenText":"LinkChannel_hiddenText__yzpUX"};